"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Braille2Ascii = exports.Braille2Numeric = exports.Ascii2Braille = exports.Numeric2Braille = exports.Unicode2Bldt = exports.Unicode2Nabt = exports.Bldt2Unicode = exports.Nabt2Unicode = void 0;
var transformers_1 = require("./transformers");
var BrfTransformer = (function (_super) {
    __extends(BrfTransformer, _super);
    function BrfTransformer(src, dst) {
        var _this = _super.call(this, src, dst) || this;
        _this.translate = new Map();
        _this.setupMap();
        return _this;
    }
    BrfTransformer.getFormat = function (kind) {
        return (kind.toUpperCase() === 'BLDT' ? BrfTransformer.format.BLDT :
            BrfTransformer.format.NABT);
    };
    BrfTransformer.prototype.via = function (src) {
        var e_1, _a;
        var result = '';
        try {
            for (var _b = __values(src.split('')), _c = _b.next(); !_c.done; _c = _b.next()) {
                var str = _c.value;
                var dst = this.translate.get(str.toLowerCase());
                if (!dst) {
                    throw new Error('Illegal input character: ' + str);
                }
                result += dst;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return result;
    };
    BrfTransformer.prototype.cleanInput = function (str) {
        var e_2, _a;
        var input = [];
        var error = [];
        try {
            for (var _b = __values(str.split('')), _c = _b.next(); !_c.done; _c = _b.next()) {
                var char = _c.value;
                if (this.translate.get(char) !== undefined) {
                    input.push(char);
                }
                else {
                    error.push(char);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return [input.join(''), error.join(', ')];
    };
    BrfTransformer.format = {
        NABT: ' a1b\'k2l@cif/msp"e3h9o6r^djg>ntq,*5<-u8v.%[$+x!&;:4\\0z7(_?w]#y)=',
        BLDT: ' a1b\'k2l`cif/msp"e3h9o6r~djg>ntq,*5<-u8v.%{$+x!&;:4|0z7(_?w}#y)='
    };
    return BrfTransformer;
}(transformers_1.AbstractTransformer));
var Unicode2Brf = (function (_super) {
    __extends(Unicode2Brf, _super);
    function Unicode2Brf() {
        var _this = _super.call(this, 'expected', '') || this;
        _this.dst = _this.kind();
        return _this;
    }
    Unicode2Brf.prototype.setupMap = function () {
        var e_3, _a;
        var count = 0;
        try {
            for (var _b = __values(BrfTransformer.getFormat(this.kind()).split('')), _c = _b.next(); !_c.done; _c = _b.next()) {
                var str = _c.value;
                this.translate.set(String.fromCodePoint(0x2800 + count++), str);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    return Unicode2Brf;
}(BrfTransformer));
var Brf2Unicode = (function (_super) {
    __extends(Brf2Unicode, _super);
    function Brf2Unicode() {
        var _this = _super.call(this, '', 'expected') || this;
        _this.src = _this.kind();
        return _this;
    }
    Brf2Unicode.prototype.setupMap = function () {
        var e_4, _a;
        var count = 0;
        try {
            for (var _b = __values(BrfTransformer.getFormat(this.kind()).split('')), _c = _b.next(); !_c.done; _c = _b.next()) {
                var str = _c.value;
                this.translate.set(str, String.fromCodePoint(0x2800 + count++));
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    return Brf2Unicode;
}(BrfTransformer));
var Nabt2Unicode = (function (_super) {
    __extends(Nabt2Unicode, _super);
    function Nabt2Unicode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Nabt2Unicode.prototype.kind = function () {
        return 'NABT';
    };
    return Nabt2Unicode;
}(Brf2Unicode));
exports.Nabt2Unicode = Nabt2Unicode;
var Bldt2Unicode = (function (_super) {
    __extends(Bldt2Unicode, _super);
    function Bldt2Unicode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Bldt2Unicode.prototype.kind = function () {
        return 'BLDT';
    };
    return Bldt2Unicode;
}(Brf2Unicode));
exports.Bldt2Unicode = Bldt2Unicode;
var Unicode2Nabt = (function (_super) {
    __extends(Unicode2Nabt, _super);
    function Unicode2Nabt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Unicode2Nabt.prototype.kind = function () {
        return 'NABT';
    };
    return Unicode2Nabt;
}(Unicode2Brf));
exports.Unicode2Nabt = Unicode2Nabt;
var Unicode2Bldt = (function (_super) {
    __extends(Unicode2Bldt, _super);
    function Unicode2Bldt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Unicode2Bldt.prototype.kind = function () {
        return 'BLDT';
    };
    return Unicode2Bldt;
}(Unicode2Brf));
exports.Unicode2Bldt = Unicode2Bldt;
var FromMultikey = (function (_super) {
    __extends(FromMultikey, _super);
    function FromMultikey() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FromMultikey.prototype.via = function (str) {
        return str.split(',').filter(function (x) { return x; }).
            map(this.toBraille.bind(this)).join('');
    };
    return FromMultikey;
}(BrfTransformer));
var ToMultikey = (function (_super) {
    __extends(ToMultikey, _super);
    function ToMultikey() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToMultikey.prototype.via = function (str) {
        return str.split('').map(this.fromBraille.bind(this)).join(',');
    };
    return ToMultikey;
}(BrfTransformer));
var Numeric2Braille = (function (_super) {
    __extends(Numeric2Braille, _super);
    function Numeric2Braille() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Numeric2Braille.prototype.kind = function () {
        return '1-6';
    };
    Numeric2Braille.numToBraille = function (list) {
        var e_5, _a;
        var duplicates = {};
        var code = 0;
        try {
            for (var list_1 = __values(list), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()) {
                var bit = list_1_1.value;
                if (!duplicates[bit] && bit > 0 && bit < 9) {
                    code += Math.pow(2, bit - 1);
                }
                duplicates[bit] = true;
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (list_1_1 && !list_1_1.done && (_a = list_1.return)) _a.call(list_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
        var base = parseInt('2800', 16);
        return String.fromCodePoint(base + code);
    };
    Numeric2Braille.prototype.toBraille = function (str) {
        return Numeric2Braille.numToBraille(str.split('')
            .map(function (x) { return parseInt(x, 10); }).
            filter(function (x) { return !isNaN(x); }));
    };
    Numeric2Braille.prototype.setupMap = function () {
        for (var i = 0; i <= 8; i++) {
            this.translate.set(i.toString(), 'T');
        }
        this.translate.set(',', 'T');
    };
    return Numeric2Braille;
}(FromMultikey));
exports.Numeric2Braille = Numeric2Braille;
var Ascii2Braille = (function (_super) {
    __extends(Ascii2Braille, _super);
    function Ascii2Braille() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Ascii2Braille.prototype.kind = function () {
        return 'sdf/jkl';
    };
    Ascii2Braille.prototype.toBraille = function (str) {
        var e_6, _a;
        var legal = [];
        try {
            for (var _b = __values(str.split('')), _c = _b.next(); !_c.done; _c = _b.next()) {
                var char = _c.value;
                var trans = parseInt(this.translate.get(char), 10);
                if (!isNaN(trans)) {
                    legal.push(trans);
                }
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_6) throw e_6.error; }
        }
        return Numeric2Braille.numToBraille(legal);
    };
    Ascii2Braille.prototype.setupMap = function () {
        this.translate = new Map([[',', 'T'], [' ', '0'], ['f', '1'], ['d', '2'],
            ['s', '3'], ['j', '4'], ['k', '5'], ['l', '6']]);
    };
    return Ascii2Braille;
}(Numeric2Braille));
exports.Ascii2Braille = Ascii2Braille;
var Braille2Numeric = (function (_super) {
    __extends(Braille2Numeric, _super);
    function Braille2Numeric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Braille2Numeric.prototype.kind = function () {
        return '1-6';
    };
    Braille2Numeric.unicodeToNumber = function (char) {
        var hex = char.codePointAt(0) - 0x2800;
        if (!hex) {
            return [0];
        }
        var result = [];
        for (var i = 1; i <= 8; i++) {
            var bit = hex % 2;
            if (bit) {
                result.push(i);
            }
            hex = Math.floor(hex / 2);
        }
        return result;
    };
    Braille2Numeric.prototype.fromBraille = function (str) {
        return Braille2Numeric.unicodeToNumber(str).join('');
    };
    Braille2Numeric.prototype.setupMap = function () {
        for (var i = 0; i <= 0xFF; i++) {
            this.translate.set(String.fromCodePoint(0x2800 + i), 'T');
        }
    };
    return Braille2Numeric;
}(ToMultikey));
exports.Braille2Numeric = Braille2Numeric;
var Braille2Ascii = (function (_super) {
    __extends(Braille2Ascii, _super);
    function Braille2Ascii() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.trans = {
            0: ' ', 1: 'f', 2: 'd', 3: 's', 4: 'j', 5: 'k', 6: 'l', 7: '', 8: ''
        };
        return _this;
    }
    Braille2Ascii.prototype.kind = function () {
        return 'sdf/jkl';
    };
    Braille2Ascii.prototype.fromBraille = function (str) {
        var _this = this;
        return Braille2Numeric.unicodeToNumber(str)
            .map(function (x) { return _this.trans[x]; }).join('');
    };
    Braille2Ascii.prototype.setupMap = function () {
        for (var i = 0; i <= 0x3F; i++) {
            this.translate.set(String.fromCodePoint(0x2800 + i), 'T');
        }
    };
    Braille2Ascii.prototype.via = function (str) {
        return _super.prototype.via.call(this, str) + ',';
    };
    return Braille2Ascii;
}(Braille2Numeric));
exports.Braille2Ascii = Braille2Ascii;
